import { player } from '../utils/player.js';
/**
 * @callback
 * */
export const UITrackMixin = (constructor) => {
    return class extends constructor {
        /**
         * @param {Track | undefined} track
         * @param {Playlist | undefined} playlist
         * */
        constructor({ track, playlist }) {
            super();
            this.track = track;
            this.playlist = playlist;
        }
        connectedCallback() {
            /** Если текущий трек играет уже, то при монтировании врубаем стили. */
            if (this.isTrackPlaying)
                this.visualPlay();
            /** Если спущено событие проигрывания трека, а он уже запущен, то ничего не делаем. Если не запущен, то врубаем стили
             * проигрывания. Если запускается другой трек, то визуально вырубаем все остальное. */
            player.addEventListener('play', () => this.updateVisual());
            /** Если поставили на паузу, то вырубаем стили проигрывания, если трек совпадает с пришедшим. */
            player.addEventListener('pause', () => this.updateVisual());
        }
        get isTrackCurrent() {
            if (player.currentTrack === undefined)
                return false;
            return player.currentTrack.id === this.track.id;
        }
        get isTrackInCurrentPlaylist() {
            return player.playlist?.id === this.playlist?.id;
        }
        get isTrackPlaying() {
            return player.playing && this.isTrackCurrent;
        }
        pause() {
            player.pause();
        }
        play() {
            player.play(this.track, this.playlist);
        }
        stop() {
            player.stop();
        }
        updateVisual() {
            if (this.isTrackPlaying)
                return this.visualPlay();
            this.visualPause();
        }
    };
};
